import './Divider.scss'

type DividerVariation = 'standard' | 'sunrise' | 'palegrey'

type DividerProps = {
  variant?: DividerVariation
  className?: string
}

/**
 * **An accessible, mobile-friendly divider component**.
 * @param variant the type of divider to show, either standard or sunrise
 * @param className to add any additonal classes if needed. optional
 * @author Phillip Berger
 */
export const Divider: React.FC<DividerProps> = ({
  variant = 'standard',
  className,
}) => {
  const variantClassName = variant.toLowerCase()

  return (
    <hr
      aria-hidden="true"
      className={`CLDivider CLDivider--${variantClassName} ${className}`}
    />
  )
}
